// 2020-06-27export { MyColInputComponent } from './my-col-input.component';